export enum BookingsFilter {
  WITH = 'with',
  WITHOUT = 'without',
}
